<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <BasicAlert
    v-if="numberHcrIntraMinimumSalaries > 0"
    alertType="info"
    class="form--mandatory"
  >
    <template #label>
      <basic-text size="body-m">
        Selon les critères de prise en charge de la branche HCR, un minimum de {{ numberHcrIntraMinimumSalaries }} stagiaires est obligatoire pour les sessions en INTRA.
        <basic-link
          label="Cliquez ici pour savoir plus."
          size="small"
          @link-click="redirectExterne('https://www.akto.fr/regles-de-prise-en-charge-hotels-cafes-restaurants')"
        />

      </basic-text>
    </template>
  </BasicAlert>
  <BasicRedirection
    :show-if="!!salariéEnCours"
    @after-scroll="définirSalariéEnCours(null)"
  >
    <template #topAnchor>
      <ListeSalaries />
    </template>
    <template #bottomAnchor>
      <SaisieSalarie />
    </template>
  </BasicRedirection>
</template>

<script setup lang="ts">
  import { inject, computed } from 'vue'
  import ListeSalaries from './sections/liste/ListeSalariesSection.vue'
  import SaisieSalarie from './sections/saisie/SaisieSalarie.vue'
  import { AF_SALARIES_ACTIONS } from './useSalarieActions'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { storeToRefs } from 'pinia'
  import { idccHCR } from '@/features/domaine/regles-akto/shared/constantes'
  import { redirectExterne } from '@/features/shared/tools'

  const store = useDemandeAFStore()
  const { model } = storeToRefs(store)
  const { définirSalariéEnCours, salariéEnCours } = inject(AF_SALARIES_ACTIONS)!

  const numberHcrIntraMinimumSalaries = computed(() => {
    const isHcrPdcExterneIntra = model.value?.employeur?.etablissement?.idcc?.code === idccHCR &&
      model.value?.sousDispositif === 'PDC' &&
      model.value?.formation?.modules?.some((m) => m.typeFormation === 'ExterneIntra') &&
      (model.value?.salaries?.length ?? 0) < 2
    if (isHcrPdcExterneIntra) return 2
    return 0
  })
</script>
